import Vue from 'vue'
import VueI18n from 'vue-i18n';
import en from './locale/en'
import zhHans from './locale/zh-Hans'
const messages = {
	en:{
    ...en
  },
  zh:{
    ...zhHans
  },
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale:  localStorage.getItem('lang') || navigator.language , // set default locale
  messages, // set locale messages
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js